var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        opacity: .2;\n      }\n\n      .st0, .st1 {\n        fill: #293577;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #293577;\n        stroke-width: 2.5px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 65,
    cy: 65,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 40.231,
    y: 28.244,
    width: 49.537,
    height: 13.619
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.646 14.441 71.354 14.441 74.189 28.244 55.811 28.244 58.646 14.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "65 62.725 28.254 65.746 39.589 112.75 90.411 112.75 101.746 65.746 65 62.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "35.076 65.185 35.076 41.863 94.924 41.863 94.924 65.185"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65.008,
    y1: 49.145,
    x2: 65.01,
    y2: 71.54
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.189,
    y1: 27.52,
    x2: 87.791,
    y2: 41.122
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65,
    y1: 28.463,
    x2: 78.337,
    y2: 41.801
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.668,103.243c-2.703.587-5.138.88-7.305.88s-3.901-.268-5.201-.803c-1.3-.536-2.32-1.39-3.06-2.562-.74-1.173-1.25-2.55-1.53-4.131-.281-1.58-.421-3.569-.421-5.966,0-5.022.708-8.522,2.123-10.498s4.022-2.964,7.821-2.964c2.192,0,4.73.344,7.611,1.032l-.152,4.207c-2.525-.383-4.623-.574-6.292-.574s-2.863.224-3.577.67-1.243,1.294-1.587,2.543c-.344,1.25-.517,3.379-.517,6.387s.351,5.094,1.052,6.253c.701,1.161,2.104,1.74,4.208,1.74s4.342-.178,6.713-.535l.113,4.321Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.fa4e3392be2be1fa07c35619244df959.svg";
export { ForwardRef as ReactComponent };